
    let limit_countries = ['CN'];
    //获取外网ip方式2：ipify
    function getIpCountryToLimit(){
        $.ajax({
            url : "https://api.ipify.org/?format=json&time="+(+new Date()),
            type : "GET",
            data : {},
            dataType : "json",
            success : function(result) {
                  $.ajax({
                    url : "https://api.chuwi.com/getipaddress/index.php?ip=" + result.ip + "&flag=ipwho",
                    type : "GET",
                    success : function(result) {
                      let res = JSON.parse(result)
                      let country = res.country, country_code = res.country_code, country_img = res.flag.img;
                      // TODO: If LimitCountry Include Current IP
                      if( limit_countries.some(blockedCountry => res.country_code.includes(blockedCountry)) ) {
                        window.location.href = "https://store.chuwi.com/pages/access-denied";
                      }
                    },
                    error : function(){}
                  });
            },
            error : function(){}
        });
    }
    getIpCountryToLimit()